module.exports = __webpack_public_path__ + "img/nss-cancer-logos.edd7c9db.png";